import React, { useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";

const StepAddress = ({ initialValue, onSubmit }) => {
  const { t } = useLanguage();
  const [form, setForm] = useState(
    initialValue || { name: "", email: "", street: "", city: "", zip: "" }
  );
  const [touched, setTouched] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const isValid =
    form.name.trim() &&
    form.email.trim() &&
    form.street.trim() &&
    form.city.trim() &&
    form.zip.trim();

  const handleSubmit = () => {
    setTouched(true);
    if (!isValid) return;
    onSubmit(form);
  };

  return (
    <div className="step">
      <h3>{t("address.title")}</h3>
      <input name="name" placeholder={t("address.name")} value={form.name} onChange={handleChange} />
      <input name="email" type="email" placeholder={t("address.email")} value={form.email} onChange={handleChange} />
      <input name="street" placeholder={t("address.street")} value={form.street} onChange={handleChange} />
      <input name="city" placeholder={t("address.city")} value={form.city} onChange={handleChange} />
      <input name="zip" placeholder={t("address.zip")} value={form.zip} onChange={handleChange} />
      {touched && !isValid && (
        <p className="checkout-error">{t("address.incomplete")}</p>
      )}
      <div className="step-buttons">
        <span />
        <button onClick={handleSubmit}>{t("address.continue")}</button>
      </div>
    </div>
  );
};

export default StepAddress;
